import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { getSeoRoute } from "../seo";

const casePaths: Record<string, string> = {
  "Contabília": "/projetos/contabilia",
  "Contabilia": "/projetos/contabilia",
  "Atática Gestão": "/projetos/atatica-gestao",
  "Hora Piauí": "/projetos/hora-piaui",
};

const casePattern = /(Contabília|Contabilia|Atática Gestão|Hora Piauí)/g;

/**
 * Cada case vira link uma unica vez por pagina. Repetir o mesmo destino em
 * varios paragrafos nao acrescenta sinal de link interno, atrapalha a leitura
 * e quebra seletores estritos. `linked` acumula os destinos ja usados ao longo
 * da pagina inteira, entao a ordem das secoes decide qual mencao leva o link.
 */
function linkOnce(text: string, linked: Set<string>): ReactNode[] {
  return text.split(casePattern).map((part, index) => {
    const path = casePaths[part];
    if (!path || linked.has(path)) return part;
    linked.add(path);
    return <Link key={index} to={path}>{part}</Link>;
  });
}

export function withCaseReferences(sections: Array<{ paragraphs: string[] }>): ReactNode[][] {
  const linked = new Set<string>();
  return sections.map((section) => section.paragraphs.map((paragraph) => linkOnce(paragraph, linked)));
}

const relatedServices: Record<string, string[]> = {
  "criacao-de-sites-em-brasilia": ["quanto-custa-um-site", "landing-page-de-alta-conversao", "criacao-de-loja-virtual-e-commerce"],
  "quanto-custa-um-site": ["criacao-de-sites-em-brasilia", "criacao-de-loja-virtual-e-commerce", "sistema-de-gestao-sob-medida"],
  "criar-aplicativo-sob-medida": ["desenvolvimento-de-aplicativo-web-e-paineis", "integracao-de-apis-e-automacoes", "sistema-de-gestao-sob-medida"],
  "criacao-de-loja-virtual-e-commerce": ["quanto-custa-um-site", "integracao-de-apis-e-automacoes", "manutencao-e-otimizacao-de-sites"],
  "sistema-de-gestao-sob-medida": ["desenvolvimento-de-aplicativo-web-e-paineis", "integracao-de-apis-e-automacoes", "criar-aplicativo-sob-medida"],
  "integracao-de-apis-e-automacoes": ["sistema-de-gestao-sob-medida", "criacao-de-loja-virtual-e-commerce", "desenvolvimento-de-aplicativo-web-e-paineis"],
  "desenvolvimento-de-aplicativo-web-e-paineis": ["sistema-de-gestao-sob-medida", "integracao-de-apis-e-automacoes", "criar-aplicativo-sob-medida"],
};

export function ServiceConnections({ slug }: { slug: string }) {
  const slugs = relatedServices[slug] ?? ["criacao-de-sites-em-brasilia", "quanto-custa-um-site", "manutencao-e-otimizacao-de-sites"];
  const routes = slugs.filter((item) => item !== slug).map((item) => getSeoRoute(`/${item}`)).filter((route) => route?.index);
  return <nav className="service-connections" aria-label="Serviços relacionados">
    <h2>Explore o que seu projeto precisa.</h2>
    <ul>{routes.map((route) => route && <li key={route.path}><Link className="text-link" to={route.path}>{route.heading}</Link></li>)}</ul>
  </nav>;
}
